var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Card, CardHeader, CardFooter, CardBody } from 'reactstrap';
import LabelModel from '../../../models/LabelModel';
import Signals from '../../../signals/Signals';
import Page from '../Page';
import { ApplicationContext } from '../../../ApplicationContext';
import Label from '../../components/ui/Label/Label';
import LabelOverlay from './LabelOverlay';
import GetOrganisationLabelsCommand from '../../../commands/labels/GetOrganisationLabelsCommand';
import DeleteLabelCommand from '../../../commands/labels/DeleteLabelCommand';
import classNames from "classnames";
import { EmptyDivRow } from "../../components/ui/EmptyRow/EmptyRow";
/**
 *
 */
var Labels = /** @class */ (function (_super) {
    __extends(Labels, _super);
    /**
     *
     */
    function Labels(props) {
        var _this = _super.call(this, props) || this;
        _this.onSearchChange = _this.onSearchChange.bind(_this);
        _this.onRemoveLabel = _this.onRemoveLabel.bind(_this);
        _this.onAddLabel = _this.onAddLabel.bind(_this);
        _this.onEditLabel = _this.onEditLabel.bind(_this);
        return _this;
    }
    /**
     *
     */
    Labels.prototype.componentDidMount = function () {
        this.componentInitialize();
    };
    /**
     *
     */
    Labels.prototype.componentInitialize = function () {
        var _a = this.context, session = _a.session, labelCollection = _a.labelCollection;
        var user = session.user;
        var command = new GetOrganisationLabelsCommand();
        command.execute(user.organisation.id, labelCollection);
    };
    /**
     *
     * @returns {*}
     */
    Labels.prototype.render = function () {
        var intl = this.props.intl;
        var session = this.context.session;
        if (!this.context.session.isLoggedIn) {
            return null;
        }
        return (React.createElement(Page, { pageName: "labels" },
            React.createElement("div", { className: "pb-4 h-100" },
                React.createElement(Card, { className: "mh-100", style: { width: "95%", borderRadius: "0px 20px 20px 0px" } },
                    React.createElement(CardHeader, { className: "flex-column flex-shrink-0 align-items-start" },
                        React.createElement("h1", { className: "card-header-title" },
                            React.createElement(FormattedMessage, { id: "page.labels.title" }))),
                    React.createElement(CardBody, { className: "pt-0 mr-4 pr-0 overflow-auto" },
                        React.createElement("div", { className: "table-container w-100 h-100 flex-fill" },
                            React.createElement("div", { className: "w-100", style: {
                                    display: "grid",
                                    gridTemplateColumns: "1fr 3fr 5fr 2fr" + (session.user.isOwner ? " 2fr" : ""),
                                    rowGap: "1.3rem",
                                    minWidth: "fit-content"
                                } },
                                React.createElement("div", { className: 'w-100 position-sticky text-nowrap text-uppercase bg-secondary px-3 pb-2 table-header', style: { display: "contents", top: 0, zIndex: 1 } },
                                    React.createElement("div", null,
                                        React.createElement(FormattedMessage, { id: "page.labels.table.column.color" })),
                                    React.createElement("div", null,
                                        React.createElement(FormattedMessage, { id: "page.labels.table.column.name" })),
                                    React.createElement("div", null,
                                        React.createElement(FormattedMessage, { id: "page.labels.table.column.description" })),
                                    React.createElement("div", null,
                                        React.createElement(FormattedMessage, { id: "page.labels.table.column.label" })),
                                    session.user.isOwner ?
                                        React.createElement("div", null)
                                        : null),
                                this._getRows()))),
                    React.createElement(CardFooter, null,
                        React.createElement("div", { className: "d-flex justify-content-end" }, session.user.isOwner &&
                            React.createElement("button", { className: "btn btn-primary", type: "submit", onClick: this.onAddLabel },
                                React.createElement("span", { className: "fe fe-plus" }),
                                " ",
                                React.createElement(FormattedMessage, { id: "page.labels.addlabel" }))))))));
    };
    /**
     *
     * @return {*}
     * @private
     */
    Labels.prototype._getRows = function () {
        var _this = this;
        var _a = this.context, session = _a.session, labelCollection = _a.labelCollection;
        var classes = classNames({
            'labels__row': true,
            "bg-white": true,
            "w-100": true,
            'mb-4': true,
            "pl-3": true,
            "pr-3": true,
            'pt-4': true,
            'pb-4': true,
        });
        if (labelCollection.filtered.length === 0) {
            return React.createElement(EmptyDivRow, null);
        }
        return labelCollection.filtered.map(function (label) {
            //
            return (React.createElement("div", { style: { display: "contents" }, key: 'label-' + label.name, className: classes },
                React.createElement("div", { className: "text-nowrap align-middle" },
                    React.createElement("div", { className: "rounded-circle mx-auto", style: { backgroundColor: label.color, width: 20, height: 20 } })),
                React.createElement("div", { className: "text-nowrap align-middle" }, label.name),
                React.createElement("div", { className: "text-nowrap align-middle text-muted" }, label.description),
                React.createElement("div", { className: "text-center align-middle" },
                    React.createElement(Label, { model: label })),
                session.user && session.user.isOwner &&
                    React.createElement("div", { className: "pr-4 align-middle text-nowrap" },
                        React.createElement("button", { className: "btn btn-sm btn-outline-danger", onClick: _this.onRemoveLabel, "data-id": label.id },
                            React.createElement("i", { className: "fe fe-trash" }),
                            " ",
                            React.createElement(FormattedMessage, { id: "page.labels.removelabel" })))));
        });
    };
    /**
     *
     * @param event
     */
    Labels.prototype.onRemoveLabel = function (event) {
        var intl = this.props.intl;
        var _a = this.context, session = _a.session, labelCollection = _a.labelCollection;
        var label = labelCollection.findById(event.currentTarget.dataset.id);
        var params = { name: label.name };
        //title, body, confirmText = 'Ok', cancelText = 'Cancel', onConfirm = null, onCancel = null
        Signals.ShowConfirmModal.dispatch(intl.formatMessage({ id: 'page.labels.removelabel.confirm.title' }, params), intl.formatHTMLMessage({ id: 'page.labels.removelabel.confirm.body' }, params), intl.formatMessage({ id: 'page.labels.removelabel.confirm.yes' }, params), intl.formatMessage({ id: 'page.labels.removelabel.confirm.no' }, params), function () {
            var command = new DeleteLabelCommand();
            command.execute(label, session.user.organisation.id, labelCollection, intl);
        });
    };
    /**
     *
     * @param event
     */
    Labels.prototype.onEditLabel = function (event) {
        var labelCollection = this.context.labelCollection;
        var target = event.currentTarget;
        var label = labelCollection.findById(target.dataset.id);
        Signals.ShowOverlay.dispatch((React.createElement(LabelOverlay, { labelModel: label })));
    };
    /**
     *
     */
    Labels.prototype.onAddLabel = function () {
        Signals.ShowOverlay.dispatch((React.createElement(LabelOverlay, { labelModel: new LabelModel() })));
    };
    /**
     *
     * @param value
     */
    Labels.prototype.onSearchChange = function (value) {
        var labelCollection = this.context.labelCollection;
        labelCollection.searchStringFilter.value = value.toLowerCase();
        labelCollection.update();
    };
    Labels = __decorate([
        observer
    ], Labels);
    return Labels;
}(React.Component));
Labels.contextType = ApplicationContext;
export default injectIntl(Labels);
